import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
  SimpleChanges,
} from "@angular/core";
import { faFileExcel } from "@fortawesome/pro-solid-svg-icons";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { GlobalHeaderDataService } from "../global-header-data.service";
import * as Action from "../../store/actions/global-header.actions";
import {
  NTM_STM_OPTIONS,
  CALENDARIZATION_OPTIONS,
  GLOBAL_SETTINGS_LOG_ACTION_FEATURES,
  GLOBAL_SETTINGS_MODAL,
} from "../global-header.constant";
import { environment } from "src/environments/environment";
import { NzModalRef } from "ng-zorro-antd/modal";
import { VAIconRegistryService, infoCircle } from "@va/core-library/icons";
import { AppService } from "src/app/app.service";
@Component({
  selector: "app-global-user-settings",
  templateUrl: "./global-user-settings.component.html",
  styleUrls: ["./global-user-settings.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class GlobalUserSettingsComponent implements OnInit {
  @Input() isVisibleEteModal = false;
  @Input() showExcelAdvanceOptions = false;
  @Input() showClose = true;

  @Output() close = new EventEmitter<any>();
  faFileExcel = faFileExcel;
  globalSettings: any = {};
  isUserSelected = false;
  addinExportModal: NzModalRef;
  hasAdjustedInterims = false;
  ltmntlstmCalculationMethod = "";
  currencyCompatible = "";
  tickerType = "";
  tabs = [];
  gsDataToSave: any = {};
  ntmStmOptions = NTM_STM_OPTIONS;
  calendarizationOptions = CALENDARIZATION_OPTIONS;
  blankValue = "";
  isRTDDisabled = false;
  percentAbsValue = false;
  gblSettingModalTitle = "Global Settings";
  calendarization_method_image: string;
  ltm_ntm_stm_calculation_method_image: string;
  @ViewChild("periodSettingsContent")
  periodSettingsContent: TemplateRef<any>;
  @ViewChild("excelSettingContent")
  excelSettingContent: TemplateRef<any>;
  @ViewChild("excelSettingContentAdvanced")
  excelSettingContentAdvanced: TemplateRef<any>;
  @ViewChild("periodSettingCustomIcon")
  periodSettingCustomIcon: TemplateRef<any>;
  //tab detail for global settings menu
  globalSettingsData: any = {};
  selectedTabIndex = 1;
  @Input() excelAdvancedDefault = {
    preferred_no_data_format: this.blankValue,
    is_RTD_disabled: this.isRTDDisabled,
    percent_value_multiplication_factor: this.percentAbsValue ? 1 : 0.01,
  };

  constructor(
    private store: Store<AppState>,
    private dataService: GlobalHeaderDataService,
    private iconRegistry: VAIconRegistryService,
    private appService: AppService,
  ) {
    this.iconRegistry.registerIcons([infoCircle]);
  }

  ngOnInit(): void {
    this.calendarization_method_image = `${environment.assetUrl}/calendarization_method.png`;
    this.ltm_ntm_stm_calculation_method_image = `${environment.assetUrl}/ltm_ntm_stm_calculation_method_image.png`;
    this.dataService.getUserSettings().subscribe((resp) => {
      if (resp["status"] === "success") {
        this.store.dispatch(new Action.SetGlobalAppSettings(resp["data"]));
        this.globalSettingsData = resp["data"];
        this.hasAdjustedInterims =
          resp["data"]["period_settings"]["cy_fy_calculation_method"] !==
          "Annualized";
        this.ltmntlstmCalculationMethod =
          resp["data"]["period_settings"][
            "rolling_period_calculation_method"
          ] === "Unreported"
            ? "Unreported"
            : "NotUnreported";
        this.currencyCompatible =
          resp["data"]["addin_export_settings"]["currency_compatible"];
        window.currencyCompatible = this.currencyCompatible;
        this.tickerType = resp["data"]["addin_export_settings"]["ticker_type"];
        window.userSettingTicker = this.tickerType;
      }
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (this.periodSettingsContent && this.tabs.length === 0) {
      this.tabs = [
        {
          title: "Customize",
          header: true,
          icon: null,
          seperator: false,
          template: null,
        },
        {
          title: "Period Settings",
          header: false,
          icon: null,
          svgIconTemplate: this.periodSettingCustomIcon,
          seperator: false,
          template: this.periodSettingsContent,
        },
        {
          title: "Excel Settings",
          header: false,
          icon: this.faFileExcel,
          seperator: false,
          template: this.showExcelAdvanceOptions
            ? this.excelSettingContentAdvanced
            : this.excelSettingContent,
        },
      ];
    }
    if (
      changes.excelAdvancedDefault &&
      changes.excelAdvancedDefault.currentValue.blankValue !== ""
    ) {
      if (this.showExcelAdvanceOptions) {
        this.blankValue =
          changes.excelAdvancedDefault.currentValue.preferred_no_data_format;
        this.isRTDDisabled =
          changes.excelAdvancedDefault.currentValue.is_RTD_disabled;
        this.percentAbsValue =
          changes.excelAdvancedDefault.currentValue
            .percent_value_multiplication_factor === 1;
      }
    }
  }

  onCloseEteModal() {
    this.store
      .select(stateGetter("globalHeader", "globalAppSettings"))
      .subscribe((data: AppState) => {
        this.hasAdjustedInterims =
          data["period_settings"]["cy_fy_calculation_method"] !== "Annualized";
        this.ltmntlstmCalculationMethod =
          data["period_settings"]["rolling_period_calculation_method"] ===
          "Unreported"
            ? "Unreported"
            : "NotUnreported";

        this.currencyCompatible =
          data["addin_export_settings"]["currency_compatible"];
        window.currencyCompatible = this.currencyCompatible;
        this.tickerType = data["addin_export_settings"]["ticker_type"];
        window.userSettingTicker = this.tickerType;
        if (this.showExcelAdvanceOptions) {
          this.blankValue =
            data["addin_export_settings"][
              "advanced_options"
            ].preferred_no_data_format;
          this.isRTDDisabled =
            data["addin_export_settings"][
              "advanced_options"
            ].currentValue.is_RTD_disabled;
          this.percentAbsValue =
            data["addin_export_settings"]["advanced_options"]
              .percent_value_multiplication_factor === 1;
        }
      });
    this.isVisibleEteModal = false;
    this.close.emit(this.isVisibleEteModal);
  }

  onApplyClick() {
    this.gsDataToSave = {
      addin_export_settings: {
        ticker: "",
        jsonData: {
          ticker_type: this.tickerType,
          currency_compatible: this.currencyCompatible,
        },
      },
      period_settings: {
        jsonData: {
          cy_fy_calculation_method: this.hasAdjustedInterims
            ? "VA Best"
            : "Annualized",
          rolling_period_calculation_method:
            this.ltmntlstmCalculationMethod === "NotUnreported"
              ? this.hasAdjustedInterims
                ? "VA Best"
                : "Annualized"
              : this.ltmntlstmCalculationMethod,
        },
      },
    };

    this.dataService.saveUserSettings(this.gsDataToSave).subscribe(
      (res) => {
        if (res["status"] === "success") {
          this.setValuesToStore();
          this.onCloseEteModal();
          this.appService.logUserAction(
            {},
            "",
            "",
            GLOBAL_SETTINGS_LOG_ACTION_FEATURES.updateGlobalPeriodSettings,
            this.gsDataToSave.period_settings.jsonData,
            "",
            GLOBAL_SETTINGS_MODAL,
          );
        } else if (this.showExcelAdvanceOptions) {
          this.setValuesToStore();
          this.isVisibleEteModal = false;
          this.close.emit(this.isVisibleEteModal);
        }
      },
      (error) => {
        //set to store even if api fails
        console.error(`applied global settings failed..${error}`);
        this.setValuesToStore();
      },
    );
  }

  setValuesToStore() {
    this.selectedTabIndex = 1;
    const payload = {
      addin_export_settings: {
        ticker_type: this.tickerType,
        currency_compatible: this.currencyCompatible,
        advanced_options: {
          preferred_no_data_format: this.blankValue,
          is_RTD_disabled: this.isRTDDisabled,
          percent_value_multiplication_factor: this.percentAbsValue ? 1 : 0.01,
        },
      },
      period_settings: {
        cy_fy_calculation_method: this.hasAdjustedInterims
          ? "VA Best"
          : "Annualized",
        rolling_period_calculation_method:
          this.ltmntlstmCalculationMethod === "NotUnreported"
            ? this.hasAdjustedInterims
              ? "VA Best"
              : "Annualized"
            : this.ltmntlstmCalculationMethod,
      },
    };
    this.store.dispatch(new Action.SetGlobalAppSettings(payload));
  }
}
